module.exports = __webpack_public_path__ + "static/media/style.4283c1e1.svg";